define('orb/features/_cookieprompt', ['orb/lib/_script', 'orb/nav'], function (script, nav) {
    function addCookieBanner(cookiePromptTemplate) {

        var urlPrefix = window.orb.bbcUrlPrefix + 'bbc.com';

        var matches = window.location.host.match(/(bbc(?:\.co\.uk))(:\d+)?(\/.*)?$/i);
        if (matches && matches[1] === 'bbc.co.uk') {
            urlPrefix = urlPrefix.replace('bbc.com', 'bbc.co.uk');
        }

        var parsedHTML = cookiePromptTemplate.replace(/<<bbcUrlPrefix>>/g, urlPrefix);

        var cookiePrompt = document.getElementById('cookiePrompt');
        cookiePrompt.innerHTML = parsedHTML;

        window.bbcpage.trackRegion(cookiePrompt, {linkLocation: 'nav-banner-cookies'});
        window.bbcuser.logEvent('view', 'nav-banner-cookies');

    }

    var cssUrl = window.orb.staticHost + "/css/bbccookies.min.css";
    
    function showCookieBanner(isUK) {
        nav.loadCss(cssUrl, function () {
            var url;

            if (window.orb.lang === 'en' || window.orb.lang === 'cy' || window.orb.lang === 'gd' || window.orb.lang === 'ga') {
                url = window.orb.staticHost + "/cookie-prompt/" + window.orb.lang;
            } else {
                url = window.orb.staticHost + "/cookie-prompt/en"
            }

            if (isUK) {
                url += ".js";
            } else {
                url += "-nonuk-eu.js";
            }

            script.jsonp(url, addCookieBanner, { callbackName: "cookiePrompt" });
            window.bbcuser.resetCookiesPreferences();
        });
    }

    function initCookiePrompt() {
        window.bbcuser.getCountry()
            .then(function(country) {
                Promise.all([
                    window.bbcuser.hasCookiesEnabled(),
                    window.bbcuser.hasSeenCookieBanner(),
                    window.bbcuser.isUKCombined(country),
                    window.bbcuser.isEU(country)
                    ]).then(function(conditions) {
                    var cookiesEnabled = conditions[0],
                        seenCookieBanner = conditions[1],
                        isUK = conditions[2],
                        isEU = conditions[3];

                    if (cookiesEnabled && seenCookieBanner) {
                        return;
                    }

                    if (isUK || isEU) {
                        showCookieBanner(isUK);
                    }
                }).catch(function(error) {
                    showCookieBanner(true);
                });
        }).catch(function(error) {
            showCookieBanner(true);
        });
    }

    return initCookiePrompt;
});
